import { Component, ContentChild, input, Input } from "@angular/core";
import { Store } from "devextreme/data";
import { PageDatagridColumnCelltemplateDirective } from "./page-datagrid-column-celltemplate.directive";
import { PlatformType } from "src/app/common/platform-type";
import { DataSourceOptions } from "devextreme/common/data";

@Component({
  selector: "pms-page-datagrid-column",
  template: "",
  standalone: false
})
export class PageDatagridColumnComponent {
  @Input()
  name: string = "";

  @Input()
  dataField!: string;

  @Input()
  caption!: string;

  @Input()
  minWidth!: number;

  @Input()
  calculateCellValue!: (row: any) => string | number;

  @Input()
  calculateDisplayValue!: (row: any) => string | number;

  @Input()
  allowFiltering: boolean = true;

  @Input()
  filterMinLength: number | undefined = undefined;

  @Input()
  allowSorting: boolean = false;

  @Input()
  allowHeaderFiltering: boolean = true;

  @Input()
  filterOperations:
    | Array<
        | "="
        | "<>"
        | "<"
        | "<="
        | ">"
        | ">="
        | "contains"
        | "endswith"
        | "isblank"
        | "isnotblank"
        | "notcontains"
        | "startswith"
        | "between"
      >
    | undefined = undefined;

  @Input()
  selectedFilterOperation: string | undefined = undefined;

  @Input()
  filterValue: any | undefined = undefined;

  @Input()
  filterValues: any[] | undefined = undefined;

  @Input()
  filterType: "include" | "exclude" = "include";

  @Input()
  headerFilter:
    | {
        dataSource:
          | Store
          | DataSourceOptions
          | { paginate: boolean; pageSize: number; store: Store };
        allowSelectAll?: boolean;
        singleChoice?: boolean;
        search?: {
          enabled: boolean;
        };
      }
    | undefined = undefined;

  @Input()
  width!: number;

  @Input()
  alignment: "center" | "left" | "right" | undefined;

  @Input()
  dataType: "string" | "number" | "date" | "boolean" | "object" | "datetime" =
    "string";

  @Input()
  cssClass: string = "";

  @Input()
  cssClassCursor: string = "cursor-pointer";

  @Input()
  hidingPriority: number | undefined = undefined;

  @Input()
  hideOnViewport: string | undefined;

  @Input()
  fixed: boolean = false;

  @Input()
  fixedPosition: "left" | "right" | undefined;

  @Input()
  groupIndex: number | undefined;

  @Input()
  visible: boolean = true;

  @Input()
  hideOnPlatforms: PlatformType[] | undefined;

  filterPlaceholder = input<string>("");

  @ContentChild(PageDatagridColumnCelltemplateDirective)
  cellTemplate: PageDatagridColumnCelltemplateDirective | null = null;
}
